export default __webpack_public_path__ + "static/media/LAS0720.34I-37964_-22244_0.21a52ce0.jpg";